import React from 'react'
import { useToleranceGroupInput } from './UseToleranceGroupInput'
import { getToleranceValueLimits, isInvalidToleranceValue } from './toleranceValidation'

type ToleranceGroupInputProps = {
  dbValue: number | null
  cpgValue: number | null
  field: string
  onChange: (value: number | null) => void
}

const ToleranceGroupInput = ({ dbValue, cpgValue, field, onChange }: ToleranceGroupInputProps) => {
  const { value, handleChange } = useToleranceGroupInput({ dbValue, onChange })

  const { minValue, maxValue } = getToleranceValueLimits(field)

  return (
    <div className="flex">
      <span
        className="flex items-center px-1 bg-blue border border-r-0 rounded-l-[10px] w-3"
        title="Existing value in cpg file"
      >
        {cpgValue}
      </span>
      <input
        type="number"
        min={minValue}
        max={maxValue}
        className={`border text-center rounded-r-[10px] !rounded-tl-none !rounded-bl-none mr-1 ${
          value !== '' && isInvalidToleranceValue(Number(value), field) ? '!border-red' : ''
        }`}
        value={value}
        onChange={handleChange}
        placeholder={`${minValue} - ${maxValue}`}
      />
    </div>
  )
}
export default ToleranceGroupInput
